import clsx from 'clsx';
import { AVAILABLE_GENDERS } from '../../utils/Validator';

const GenderSelector = ({
  value,
  onChange,
  options = AVAILABLE_GENDERS,
  showError = false,
}) => {
  return (
    <>
      {showError && !value && (
        <p className="text-[#FF2E6C] text-xl geomanistRegular font-semibold">
          Ton genre est obligatoire pour continuer.
        </p>
      )}
      <div className="genre-buttons">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            className={clsx(
              'genre-button',
              {
                'bg-gradient1 active': value === option,
              },
            )}
            onClick={() => onChange(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </>
  );
};

export default GenderSelector;
